<template>
<div class="chapter">
<div class="inner_page">
<div id="cover">
<img alt="Appleby Talks Again" class="cover-image" src="images/appleby-talks-again-ebook-cover-1600-x-2560px.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?68d7e42d